module.exports = __webpack_public_path__ + "img/logo.8910e353.png";